// This file is automatically generated. Do not edit manually.

export const hiddenLocales = [
  "fr",
  "es"
] as const

export type HiddenLocale = typeof hiddenLocales[number];
